<template>
  <div>
    <div v-loading="dxLoading" element-loading-spinner="atom-audit-loader" style="margin-top: 5px;">
      <div v-if="toggleGrid" class="hiaTable" :class="{ level2: proReview.isLevel2 }">
        <table ref="dxGrid" id="dxGrid" class="dx-table">
          <thead>
            <tr>
              <th class="lineSequenceCol">#</th>

              <th v-if="!isPivoted" class="codeTypeCol">
                Code Type
              </th>

              <th v-if="proReview.isLevel2" class="oneHundredPx leftBorder">
                <div class="codeTypeCol">
                  <hia-el-select :disabled="proReview.isLevel2" v-model="preDxCodeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
                </div>
              </th>
              <th v-if="proReview.isLevel2" class="twentyPercent">Desc.</th>

              <th class="oneHundredPx leftBorder">
                <div class="header-flex-container" style="margin-right: 4px;">
                  <div class="codeTypeCol" v-if="isPivoted">
                    <hia-el-select :disabled="disabled || proReview.isLevel2" v-model="originalDxCodeType" @input="handleCodeTypeChange" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
                  </div>
                  <div v-if="!isPivoted">Orig. Dx</div>
                  <i class="el-icon-plus subtle-add-icon" :style="disabled ? 'cursor: not-allowed' : ''" @click="showAddMenu($event)"></i>
                </div>
              </th>
              <th class="twentyPercent">Desc.</th>
              <th v-if="proReview.isLevel2" class="actionsCol">Actions</th>
              <th class="oneHundredPx leftBorder">Rec. Dx</th>
              <th class="twentyPercent">Desc.</th>
              <th class="actionsCol">Actions</th>
              <th class="reasonForChangeCol">Reason For Change</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in proReview.proRecordDxs" :key="row.dxId" class="dx-row">
              <td class="lineSequenceCol">
                <span class="dragIcon drag-handle" style="margin-top: 3px; float: left">{{ row.lineSequence }}</span>
              </td>

              <td v-if="!isPivoted" class="codeTypeCol">
                <hia-el-select v-model="row.codeType" @input="putProRecordDx(row, 'codeType', $event)" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
              </td>

              <td v-if="proReview.isLevel2" class="oneHundredPx leftBorder">
                <div class="codeTypeCol">
                  <hiaCodeInput :ref="row.dxId + 'preDx'" style="width: 112px;" :inputId="`preDx_${index}`" class="noRightBorder borderLeftRadius" v-model="row.preDx" :disabled="disabled" @ellipsisClick="emitEllipsisClick(row.preDx)" @focus="handleCodeInputFocus(row, 'preDx')" @change="putProRecordDx(row, 'preDx', $event)"> </hiaCodeInput>
                </div>
                <span style="float: left; margin-top: 1px;" v-html="dxCodeEdits(row.preEdits)"></span>
                <span style="float: left; margin-top: 4px;" v-html="dxCodeHccs(row.preHccs)"></span>
              </td>
              <td v-if="proReview.isLevel2" class="twentyPercent">
                <div style="margin-top: 3px;">{{ row.preDxDescCalc }}</div>
              </td>

              <td class="oneHundredPx leftBorder">
                <div class="input-with-icon">
                  <HiaCodeInput :ref="row.dxId + 'origDx'" style="width: 112px;" :class="{ deleteCode: row.preDxDeleted || (!row.originalDx && row.deleteCode) }" :placeholder="row.preDx" :inputId="`originalDx_${index}`" class="noRightBorder borderLeftRadius" v-model="row.originalDx" :disabled="disabled || row.preDxDeleted || (!row.originalDx && row.deleteCode)" @ellipsisClick="emitEllipsisClick(row.originalDx)" @focus="handleCodeInputFocus(row, 'originalDx')" @change="putProRecordDx(row, 'dxCode', $event)"> </HiaCodeInput>
                  <i v-if="proReview.isLevel2 && row.originalDx && !row.preDx" title="Move Left" class="el-icon-back move-left-icon" @click="moveCodeLeft(row)"></i>
                </div>
                <span style="float: left; margin-top: 1px;" v-html="dxCodeEdits(row.edits)"></span>
                <span style="float: left; margin-top: 4px;" v-html="dxCodeHccs(row.originalHccs)"></span>
              </td>

              <td class="twentyPercent">
                <div style="margin-top: 3px;">{{ row.preDxDeleted || (!row.originalDx && row.deleteCode) ? 'Delete Code' : row.originalDescCalc }}</div>
              </td>

              <td v-if="proReview.isLevel2" class="actionsCol">
                <div style="margin-top: 5px;">
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.preDxNewPrimary" title="New Primary" icon="mdi mdi-alpha-p" :disabled="disabled" @change="putProRecordDx(row, 'preDxNewPrimary')"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.preDxDeleted" title="Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled" @change="putProRecordDx(row, 'preDxDeleted', $event)"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.preDxExclude" :title="`Exclude Changes from ${GET_VALUEFROMKEY('codeTypes', row.preDxCodeType)} Stats`" icon="mdi mdi-alpha-e" :disabled="disabled" @change="putProRecordDx(row, 'preDxExclude')"> </iconCheckBox>
                </div>
              </td>

              <td class="oneHundredPx leftBorder">
                <div>
                  <HiaCodeInput :ref="row.dxId + 'recDx'" style="width: 112px;" :placeholder="row.originalDx || row.preDx" :inputId="`recommendedDx_${index}`" :class="{ deleteCode: row.deleteCode || (!row.recommendedDx && row.preDxDeleted) }" v-model="row.recommendedDx" :disabled="row.deleteCode || disabled" @ellipsisClick="emitEllipsisClick(row.recommendedDx)" @focus="handleCodeInputFocus(row, 'recommendedDx')" @change="putProRecordDx(row, 'dxCode', $event)"> </HiaCodeInput>
                </div>
                <span style="float: left" v-html="dxCodeEdits(row.recEdits)"></span>
                <span style="float: left; margin-top: 5px;" v-html="dxCodeHccs(row.recommendedHccs)"></span>
              </td>

              <td class="twentyPercent">
                <div style="margin-top: 3px;">{{ !row.deleteCode ? row.recDescCalc : 'Delete Code' }}</div>
              </td>

              <td class="actionsCol">
                <div style="margin-top: 5px;">
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.newPrimary" title="New Primary" icon="mdi mdi-alpha-p" :disabled="disabled" @change="putProRecordDx(row, 'newPrimary')"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.deleteCode" title="Delete Code" icon="mdi mdi-alpha-d" :disabled="disabled" @change="putProRecordDx(row, 'deleteDx', $event)"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.exclude" :title="`Exclude Changes from ${GET_VALUEFROMKEY('codeTypes', row.codeType)} Stats`" icon="mdi mdi-alpha-e" :disabled="disabled" @change="putProRecordDx(row)"> </iconCheckBox>
                  <iconCheckBox style="float: left" @click="backupRow(row)" v-model="row.validated" title="Validated by Reviewer" icon="mdi mdi-alpha-v" :disabled="disabled" @change="putProRecordDx(row)"> </iconCheckBox>
                </div>
              </td>

              <td class="reasonForChangeCol">
                <hia-el-select style="width: 82%" :title="disableReasonForChange(row) ? 'No change on line' : null" :disabled="disableReasonForChange(row) || disabled" @input="putProRecordDx(row, $event)" v-model="row.reasonForChange" placeholder="Reason for Change" itemkey="key" label="value" :dropdowns="dropdowns.proReasonsForChangeDx.list" clearable filterable> </hia-el-select>
                <i v-if="!disabled" style="float: right; cursor: pointer; margin-top: -20px;" title="Delete Dx Row" class="el-icon-close delete-button" @click="deleteDx(row)"></i>
              </td>
            </tr>

            <!-- Special Add Row -->
            <tr class="add-row" key="addRow">
              <td class="lineSequenceCol">
                &nbsp;
              </td>

              <td v-show="!isPivoted" class="codeTypeCol">
                <hia-el-select key="addRowCodeType" v-model="addRow.codeType" placeholder="Code Type" itemkey="key" label="value" :dropdowns="dropdowns.codeTypes.list" filterable> </hia-el-select>
              </td>

              <td v-show="proReview.isLevel2" class="oneHundredPx ">
                <input key="addRowPreDx" style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="dxLoading" id="originalDx" maxlength="7" minlength="3" v-model="addRow.preDx" v-on:keyup.enter="addDxRow(addRow)" />
              </td>
              <td v-show="proReview.isLevel2" class="twentyPercent">
                &nbsp;
              </td>

              <td class="oneHundredPx ">
                <input key="addRowOriginalDx" style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="dxLoading" id="originalDx" maxlength="7" minlength="3" v-model="addRow.originalDx" v-on:keyup.enter="addDxRow(addRow)" />
              </td>
              <td class="twentyPercent">
                <div>&nbsp;</div>
              </td>

              <td v-show="proReview.isLevel2" class="actionsCol">
                <div>&nbsp;</div>
              </td>

              <td class="oneHundredPx ">
                <input key="addRowRecommendedDx" style="width: 100px; text-transform: uppercase; font-size: 12px" v-mask="'NNNNNNN'" :disabled="disabled" :readonly="dxLoading" id="recommendedDx" maxlength="7" minlength="3" v-model="addRow.recommendedDx" v-on:keyup.enter="addDxRow(addRow)" />
              </td>
              <td class="twentyPercent">
                <div>&nbsp;</div>
              </td>
              <td class="actionsCol">
                <div>&nbsp;</div>
              </td>
              <td class="reasonForChangeCol">
                <el-popover ref="addPopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="addPopoverContent" v-model="showAddPopover" @after-enter="handleHidePopOver('addPopover')">
                  <el-button key="addRowAddButton" :disabled="disabled" round slot="reference" style="float: right;" icon="el-icon-plus" type="primary" size="mini" @click="addDxRow(addRow)">Add </el-button>
                </el-popover>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="dialogs">
      <addMultipleCodes :disabled="disabled" :defaultCodeType="proReview.project.defaultCodeType" :codeTypeRequired="true" :show="showAddMultipleCodes" :type="'DX'" :review="proReview" @close="handleCloseAddMultipleCodes" @postAddMultipleCodes="postAddMultipleCodes"> </addMultipleCodes>
    </div>

    <el-popover ref="savePopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" @after-enter="handleHidePopOver('savePopover')"> </el-popover>

    <!-- Context Menu for Add Left/Right -->
    <div v-if="showContextMenu" class="context-menu" :style="contextMenuStyle" @click.stop>
      <template v-if="!proReview.isLevel2 && isPivoted">
        <template v-if="originalDxCodeType">
          <div v-for="codeType in moveLeftCodeTypes" :key="codeType.key" class="context-menu-item" @click="copyLeft(codeType)">
            <i class="el-icon-arrow-left"></i>
            Add Left {{ codeType.value }}
          </div>
        </template>
        <template v-else>
          <div class="context-menu-item" style="cursor: not-allowed;">
            <i class="el-icon-warning" style="color: red;"></i>
            Choose Code Type to Add Left
          </div>
        </template>
      </template>
      <div v-if="proReview.isLevel2" class="context-menu-item" @click="removeLeft">
        <i class="el-icon-remove-outline"></i>
        Remove Left
      </div>
      <div v-if="isPivoted && !proReview.isLevel2" class="context-menu-item" @click="unPivot">
        <i class="el-icon-refresh"></i>
        Un-pivot Code Types
      </div>
      <div v-if="!isPivoted" class="context-menu-item" @click="pivot">
        <i class="el-icon-refresh"></i>
        Pivot Code Types
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
  import iconCheckBox from '@/components/controls/iconCheckBox'
  import HiaCodeInput from '@/components/controls/HiaCodeInput'
  import Sortable from 'sortablejs'
  import addMultipleCodes from '@/components/controls/addMultipleCodes'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'proReviewDx',
    props: ['showAddMultipleCodes'],
    mixins: [HiaAuthorization],
    data: function() {
      return {
        activeRowBackup: {},
        toggleGrid: true,
        isPivoted: true,
        theSortable: null,
        localOriginalDxCodeType: '',
        localPreDxCodeType: '',
        addPopoverContent: '',
        savePopoverContent: '',
        showAddPopover: false,
        showContextMenu: false,
        contextMenuStyle: {
          position: 'fixed',
          top: '0px',
          left: '0px'
        },
        addRow: { codeType: '', originalDx: '', recommendedDx: '', preDx: '' }
      }
    },
    components: {
      iconCheckBox,
      HiaCodeInput,
      addMultipleCodes
    },
    methods: {
      ...mapActions('proReviews/', ['PUT_PRO_DX', 'DELETE_PRO_DX', 'POST_PRO_DX', 'PUT_PRO_DXS_FOR_RESEQUENCE', 'PUT_PRO_DX_CHILD', 'COPY_PRO_DX_LEFT', 'POST_PRO_DX_CHILD', 'PUT_PRO_DX_MASS_UPDATE']),
      ...mapMutations('proReviews/', ['SET_PRO_DX_ROW', 'PUSH_DX_ROW', 'SET_PRO_DXS']),
      shouldConfirmReasonClear(row) {
        if (!row || !row.reasonForChange) {
          return false
        }
        const noRecommendations = !row.recommendedDx && !row.deleteCode && !row.newPrimary
        if (!noRecommendations) {
          return false
        }
        if (this.proReview && this.proReview.isLevel2) {
          return !row.originalDx && !row.preDxDeleted && !row.preDxNewPrimary
        }
        return true
      },
      handleCodeInputFocus(row, prop) {
        this.backupRow(row)
        this.emitFocusedCode(row[prop])
      },
      backupRow(row) {
        this.activeRowBackup = { ...row }
      },
      async putProRecordDx(row, changedField, e) {
        if (!row.recommendedDx && !row.originalDx && !row.preDx) {
          let message = 'Either the Original Dx or Recommended Dx must be populated. To delete the entire row, use the X button on the right side.'
          if (this.proReview.isLevel2) {
            message = `Either the ${this.GET_VALUEFROMKEY('codeTypes', row.preDxCodeType)} Dx, ${this.GET_VALUEFROMKEY('codeTypes', row.codeType)} Dx or Recommended Dx must be populated. To delete the entire row, use the X button on the right side.`
          }
          this.savePopoverContent = message
          this.openSavePopover(e)
          this.SET_PRO_DX_ROW(this.activeRowBackup)
          return
        }

        if (!(row.originalDx || row.preDx) && changedField === 'deleteDx') {
          row.deleteCode = false
          this.savePopoverContent = 'The Delete Code recommendation cannot be used if there is no code in the Original Dx Position.'
          this.openSavePopover(e)
          return
        }

        if (!row.preDx && changedField === 'preDxDeleted') {
          row.preDxDeleted = false
          this.savePopoverContent = `The Delete Code recommendation cannot be used if there is no code in the ${this.GET_VALUEFROMKEY('codeTypes', row.preDxCodeType)} Position.`
          this.openSavePopover(e)
          return
        }

        if (this.shouldConfirmReasonClear(row)) {
          try {
            await this.$confirm('This will clear the Reason for Change. Continue?', 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.reasonForChange = null
          } catch (e) {
            this.SET_PRO_DX_ROW(this.activeRowBackup)
            return
          }
        }

        if (changedField === 'deleteDx' && row.recommendedDx && row.deleteCode) {
          try {
            await this.$confirm(`This will clear the Recommended Dx ${row.recommendedDx}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.recommendedDx = null
          } catch (e) {
            this.SET_PRO_DX_ROW(this.activeRowBackup)
            return
          }
        }

        if (changedField === 'preDxDeleted' && row.originalDx && row.preDxDeleted) {
          try {
            await this.$confirm(`This will clear the ${this.GET_VALUEFROMKEY('codeTypes', row.codeType)} ${row.originalDx}. Continue?`, 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
            row.originalDx = null
          } catch (e) {
            this.SET_PRO_DX_ROW(this.activeRowBackup)
            return
          }
        }

        const payload = { dxRow: row, changedField: changedField }

        try {
          await this.PUT_PRO_DX(payload)
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'Diagnosis Code Update Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Diagnosis Code Update Error',
            type: 'error'
          })
        }
      },
      // TEMP: simple console test for shouldConfirmReasonClear with expected outcomes
      debugTestShouldConfirm() {
        const scenarios = []
        const mkRow = o => ({
          reasonForChange: o.reasonForChange !== undefined ? o.reasonForChange : 'X',
          recommendedDx: o.recommendedDx ?? null,
          deleteCode: o.deleteCode ?? false,
          newPrimary: o.newPrimary ?? false,
          originalDx: o.originalDx ?? null,
          preDxDeleted: o.preDxDeleted ?? false,
          preDxNewPrimary: o.preDxNewPrimary ?? false
        })

        const cases = [
          { name: 'L1: reason, no rec', isLevel2: false, row: mkRow({}), expected: true },
          { name: 'L1: has recommendedDx', isLevel2: false, row: mkRow({ recommendedDx: 'A00' }), expected: false },
          { name: 'L1: has deleteCode', isLevel2: false, row: mkRow({ deleteCode: true }), expected: false },
          { name: 'L1: has newPrimary', isLevel2: false, row: mkRow({ newPrimary: true }), expected: false },
          { name: 'L1: no reason', isLevel2: false, row: mkRow({ reasonForChange: null }), expected: false },
          { name: 'L2: base true (no orig/pre flags)', isLevel2: true, row: mkRow({}), expected: true },
          { name: 'L2: has originalDx', isLevel2: true, row: mkRow({ originalDx: 'B00' }), expected: false },
          { name: 'L2: has preDxDeleted', isLevel2: true, row: mkRow({ preDxDeleted: true }), expected: false },
          { name: 'L2: has preDxNewPrimary', isLevel2: true, row: mkRow({ preDxNewPrimary: true }), expected: false },
          { name: 'L2: has recommendedDx', isLevel2: true, row: mkRow({ recommendedDx: 'C00' }), expected: false }
        ]

        const originalLevel2 = this.proReview ? this.proReview.isLevel2 : undefined
        cases.forEach(c => {
          if (this.proReview) {
            this.proReview.isLevel2 = c.isLevel2
          }
          const actual = this.shouldConfirmReasonClear(c.row)
          scenarios.push({
            scenario: c.name,
            isLevel2: c.isLevel2,
            expected: c.expected,
            actual: actual,
            pass: actual === c.expected
          })
        })
        if (this.proReview && originalLevel2 !== undefined) {
          this.proReview.isLevel2 = originalLevel2
        }
        // eslint-disable-next-line no-console
        console.table(scenarios)
        return scenarios
      },
      async handleCodeTypeChange(e) {
        if (this.proReview.proRecordDxs.length === 0) {
          return
        }
        try {
          await this.PUT_PRO_DX_MASS_UPDATE(this.proReview.proRecordDxs)
          this.$message({
            message: 'Diagnosis Code Update Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Diagnosis Code Update Error',
            type: 'error'
          })
        }
      },
      moveCodeLeft(row) {
        row.preDx = row.originalDx
        row.originalDx = null
        this.putProRecordDx(row, 'originalDx')
      },
      showAddMenu(event) {
        if (this.disabled) {
          return
        }
        event.preventDefault()
        event.stopPropagation()

        this.contextMenuStyle = {
          position: 'fixed',
          top: event.clientY + 'px',
          left: event.clientX + 'px'
        }
        this.showContextMenu = true

        // Close menu when clicking outside
        const closeMenu = e => {
          // Check if click is outside the context menu and not on the trigger element
          const contextMenu = this.$el.querySelector('.context-menu')
          const triggerElement = e.target.closest('.subtle-add-icon')

          if (contextMenu && !contextMenu.contains(e.target) && !triggerElement) {
            this.showContextMenu = false
            document.removeEventListener('click', closeMenu)
          }
        }
        document.addEventListener('click', closeMenu)
      },
      async copyLeft(codeType) {
        this.showContextMenu = false
        if (this.proReview.proRecordDxs.length > 0) {
          try {
            const payload = {
              proRecordId: this.proReview.proRecordId,
              middleCodeType: this.originalDxCodeType,
              codeType: codeType.key
            }
            await this.COPY_PRO_DX_LEFT(payload)
          } catch (e) {
            this.$message({
              message: 'Copy Left Code Update Error',
              type: 'error'
            })
          }
        } else {
          this.proReview.isLevel2 = true
          this.localPreDxCodeType = codeType.key
        }
      },
      async removeLeft() {
        this.showContextMenu = false
        if (this.proReview.proRecordDxs.length > 0) {
          try {
            const payload = {
              proRecordId: this.proReview.proRecordId,
              middleCodeType: this.originalDxCodeType,
              codeType: null
            }
            await this.COPY_PRO_DX_LEFT(payload)
          } catch (e) {
            this.$message({
              message: 'Copy Left Code Update Error',
              type: 'error'
            })
          }
        } else {
          this.proReview.isLevel2 = false
          this.localPreDxCodeType = ''
        }
      },
      unPivot() {
        this.showContextMenu = false
        this.isPivoted = false
        this.proReview.isLevel2 = false
      },
      pivot() {
        this.showContextMenu = false
        this.isPivoted = true
        this.proReview.isLevel2 = false
      },
      setAddRow(row) {
        this.addRow = row
      },
      disableReasonForChange(row) {
        // Check if there are any recommended changes
        const hasRecommendedChanges = row.recommendedDx || row.newPrimary || row.deleteCode

        // Check if there are any preDx changes (only relevant in Level 2)
        const hasPreDxChanges = this.proReview.isLevel2 && (row.originalDx || row.preDxDeleted || row.preDxNewPrimary || row.preDxExclude)

        // Disable only if there are no changes at all
        return !hasRecommendedChanges && !hasPreDxChanges
      },

      async addDxRow(row) {
        row.codeType = row.codeType || this.proReview.project.defaultCodeType || this.originalDxCodeType

        if (this.proReview.isLevel2 && !row.preDx && !row.originalDx && !row.recommendedDx) {
          this.addPopoverContent = `Either ${this.GET_VALUEFROMKEY('codeTypes', this.preDxCodeType)} Dx, ${this.GET_VALUEFROMKEY('codeTypes', this.originalDxCodeType)} Dx or Recommended Dx must be populated to add row.`
          this.showAddPopover = true
          return
        }

        if (!this.proReview.isLevel2 && !row.codeType && !row.originalDx && !row.recommendedDx) {
          this.addPopoverContent = 'Code Type and either Original DX or Recommended DX must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (!this.proReview.isLevel2 && !row.originalDx && !row.recommendedDx) {
          this.addPopoverContent = 'Either Original DX or Recommended DX must be populated to add row.'
          this.showAddPopover = true
          return
        }

        if (this.proReview.isLevel2) {
          this.addRow.codeType = this.originalDxCodeType || this.proReview.project.defaultCodeType
        }

        if (!row.codeType) {
          this.addPopoverContent = 'Code Type must be populated to add row.'
          this.showAddPopover = true
          return
        }

        row.dxId = 0
        row.proRecordId = this.proReview.proRecordId
        row.newPrimary = false
        row.originalDx = row.originalDx
          ? row.originalDx
              .toUpperCase()
              .replace('.', '')
              .trim()
          : null
        row.recommendedDx = row.recommendedDx
          ? row.recommendedDx
              .toUpperCase()
              .replace('.', '')
              .trim()
          : null

        if (this.proReview.isLevel2) {
          row.preDx = row.preDx
            ? row.preDx
                .toUpperCase()
                .replace('.', '')
                .trim()
            : null
          row.preDxCodeType = this.preDxCodeType
        }

        try {
          await this.POST_PRO_DX([row])
          this.addRow = { codeType: row.codeType, originalDx: '', recommendedDx: '', preDx: '' }
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'Diagnosis Code Added Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Diagnosis Code Add Error',
            type: 'error'
          })
        }
      },
      async deleteDx(row) {
        try {
          await this.DELETE_PRO_DX(row)
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'Diagnosis Code Deleted Successful',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Diagnosis Code Delete Error',
            type: 'error'
          })
        }
      },
      openSavePopover(e) {
        if (!e) {
          return
        }

        const popper = this.$refs.savePopover

        popper.doDestroy()
        popper.doClose()

        this.$nextTick(() => {
          this.popperClickTarget = e.target
          popper.doDestroy()
          popper.referenceElm = this.popperClickTarget
          this.isOpen = true
          popper.doShow()
        })
      },
      handleHidePopOver(ref) {
        const popper = this.$refs[ref]
        const handler = e => {
          if (e.target !== popper.$el) {
            popper.doDestroy()
            popper.doClose()
          }
          document.removeEventListener('click', handler, false)
        }
        document.addEventListener('click', handler, false)
      },
      emitEllipsisClick(code) {
        this.emitFocusedCode(code)
        this.$emit('ellipsisClick', code)
      },
      emitFocusedCode(focusedCode) {
        if (focusedCode && focusedCode !== 'DEL') {
          const truCodeQueryObject = {
            code: focusedCode,
            type: 'DX'
          }
          this.$emit('onCodeFocus', truCodeQueryObject)
        }
      },
      dxCodeEdits(edits) {
        if (edits && edits.length) {
          let dxDesc = ''
          for (const i in edits) {
            dxDesc += edits[i].description.replace(/<[^>]*>/g, '') + ' \n'
          }
          return '<div style="background: url(/static/trucode/css/img/icons/warning.png); width: 16px; height: 16px; margin-top: 2px"  title="' + dxDesc.trim() + '"></div>'
        }
        return ''
      },
      dxCodeHccs: function(hccs) {
        if (hccs && hccs.length) {
          const copy = JSON.parse(JSON.stringify(hccs))
          const sortByVersionThenValue = (a, b) => {
            if (a.version !== b.version) {
              return a.version - b.version
            }
            return a.value - b.value
          }

          copy.sort(sortByVersionThenValue)

          let html = ''
          for (let i = 0; i < copy.length; i++) {
            const title = copy[i].description
            const value = copy[i].value
            const version = copy[i].version
            if (version) {
              html += `<span class="hcc hcc${version}" title="V${version} - ${title}">${value}</span>`
            } else {
              html += `<span class="hcc" title="${title}">${value}</span>`
            }
          }
          return html
        }
        return '<div>&nbsp;</div>'
      },
      async handleDragStop(e) {
        const temp = this.proReview.proRecordDxs[e.oldIndex]
        this.proReview.proRecordDxs.splice(e.oldIndex, 1)
        this.proReview.proRecordDxs.splice(e.newIndex, 0, temp)
        this.updateLineSequence(this.proReview.proRecordDxs)
        this.SET_PRO_DXS(this.proReview.proRecordDxs)

        // force the grid to re-initialize by destroying and recreating it
        // and then reattaching the sortable
        this.toggleGrid = false
        this.theSortable.destroy()
        this.$nextTick(() => {
          this.toggleGrid = true
          this.$nextTick(() => {
            this.attachSortable()
          })
        })

        try {
          await this.PUT_PRO_DXS_FOR_RESEQUENCE(this.proReview.proRecordDxs)
          this.$emit('handleSaveToLocalStorageForTruCode', this.proReview)
          this.$message({
            message: 'Diagnosis Code Updated Successfully',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Diagnosis Code Update Error',
            type: 'error'
          })
        }
      },
      updateLineSequence(array) {
        array.map((o, i) => {
          o.lineSequence = i + 1
          return o
        })
      },
      attachSortable() {
        const gridElementName = 'dxGrid'
        const gridDiv = document.getElementById(gridElementName)
        if (gridDiv) {
          const tbody = gridDiv.getElementsByTagName('tbody')
          if (tbody[0]) {
            this.theSortable = Sortable.create(tbody[0], {
              animation: 200,
              draggable: 'tr',
              handle: '.drag-handle',
              onEnd: e => {
                this.handleDragStop(e)
              }
            })
          }
        }
      },
      handleCloseAddMultipleCodes() {
        this.$emit('handleCloseAddMultipleCodes', false)
      },
      async postAddMultipleCodes(data) {
        if (data.codes) {
          // populate new DX codes
          const newCodes = []
          let startLineSequence = this.proReview.proRecordDxs.length + 1
          data.codes.forEach((v, i) => {
            const newDxCode = {
              proRecordId: this.proReview.proRecordId,
              lineSequence: startLineSequence,
              add: true,
              originalDx: data.isRecommended ? null : v.trim(),
              exclude: false,
              validated: false,
              recommendedDx: data.isRecommended ? v.trim() : null,
              newPrimary: false,
              reasonForChange: '',
              codeType: data.codeType
            }
            newCodes.push(newDxCode)
            startLineSequence++
          })
          data.codes = newCodes
          data.changedField = 'addMultipleCodes'
          try {
            await this.POST_PRO_DX(data.codes)
            this.$message({
              message: 'Multiple Codes Added Successfully',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              message: 'Multiple Codes Added Error',
              type: 'error'
            })
          }
        }
      }
    },
    mounted: function() {
      const uniqueCodeTypes = [...new Set(this.proReview.proRecordDxs.map(dx => dx.codeType))]

      if (uniqueCodeTypes.length > 1) {
        this.isPivoted = false
      }

      this.addRow.codeType = this.originalDxCodeType

      this.$nextTick(() => {
        this.attachSortable()
        // Expose a simple console helper for ad-hoc testing (remove when done)
        if (typeof window !== 'undefined') {
          window.proDxConfirmTest = () => this.debugTestShouldConfirm()
        }
      })
    },
    watch: {
      'proReview.project.defaultCodeType': function(val) {
        if (this.proReview.project) {
          this.addRow = { codeType: this.proReview.project.defaultCodeType, originalDx: '', recommendedDx: '' }
        }
      }
    },
    computed: {
      ...mapGetters('dropdowns/', ['GET_VALUEFROMKEY']),
      ...mapState('proReviews/', ['proReview', 'dxLoading']),
      ...mapState('dropdowns/', ['dropdowns']),
      disabled() {
        return !!this.readOnly() || this.proReview.reviewStatusId !== 2
      },
      moveLeftCodeTypes() {
        return this.dropdowns.codeTypes.list.filter(ct => ct.key !== this.originalDxCodeType)
      },
      originalDxCodeType: {
        get() {
          return this.proReview.proRecordDxs[0]?.codeType || this.proReview.project.defaultCodeType || this.localOriginalDxCodeType
        },
        set(value) {
          this.addRow.codeType = value
          if (this.proReview.proRecordDxs.length > 0) {
            this.proReview.proRecordDxs.forEach(dx => {
              dx.codeType = value
            })
          } else {
            this.localOriginalDxCodeType = value
          }
        }
      },
      preDxCodeType: {
        get() {
          return this.proReview.proRecordDxs[0]?.preDxCodeType || this.localPreDxCodeType
        },
        set(value) {
          if (this.proReview.proRecordDxs.length > 0) {
            this.proReview.proRecordDxs.forEach(dx => {
              dx.preDxCodeType = value
            })
          } else {
            this.localPreDxCodeType = value
          }
        }
      }
    }
  }
</script>

<style scoped>
  .dragIcon {
    cursor: move;
    margin: 1px 0px 0px 1px;
    padding: 0px 0px 0px 0px;
    float: left;
    height: 20px;
    color: #1f2d3d;
  }

  .drag-handle {
    cursor: move;
    display: block;
    float: left;
  }

  .dx-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0;
  }

  .dx-table th,
  .dx-table td {
    padding: 8px;
    text-align: left;
    vertical-align: top;
  }

  .dx-table th {
    background-color: #f5f7fa;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
  }

  .dx-table tbody tr:nth-child(even) {
    background-color: #fafafa;
  }

  .dx-table tbody tr {
    border-top: 1px solid #e2e8f0;
  }

  .add-row {
    background-color: #fff !important;
    border-top: 1px solid #e2e8f0;
  }

  .dx-table tbody tr:hover {
    background-color: #f0f9ff;
  }

  .add-row-table {
    margin-top: 2px;
  }

  .add-row-table tbody tr {
    height: 40px;
    border-top: 1px solid #ebeef5;
    background-color: #fff !important;
  }

  .add-row th,
  .add-row td {
    vertical-align: middle;
  }

  .leftBorder {
    border-left: 2px solid #ebeef5 !important;
  }

  .lineSequenceCol {
    width: 17px;
  }

  .codeTypeCol {
    width: 130px;
  }

  .actionsCol {
    max-width: 90px;
    min-width: 90px;
  }

  .reasonForChangeCol {
    min-width: 120px;
    max-width: 140px;
  }

  .deleteCol {
    max-width: 30px;
  }

  .addCol {
    min-width: 150px;
  }

  .thirtyPx {
    min-width: 20px;
  }

  .fiftyPx {
    width: 50px;
  }

  .seventyFivePx {
    width: 75px;
  }

  .oneHundredPx {
    width: 100px;
  }

  .twentyPercent {
    width: 20%;
  }

  .descOverflow {
    word-break: break-word;
  }

  .hiaTable .el-icon-close {
    border: 1px solid transparent;
  }

  .hiaTable tr:nth-child(even) .el-icon-close {
    border: 1px solid #606266;
    border-radius: 100%;
  }

  #dxGridAddRow thead {
    visibility: collapse;
  }

  #dxGridAddRow tbody > tr {
    height: 40px;
    border-top: 1px solid #ebeef5;
    background-color: #fff !important;
  }

  #dxGrid tr {
    vertical-align: top;
  }

  #dxGrid ::placeholder {
    opacity: 0.8;
  }

  .dx-table thead tr {
    vertical-align: middle;
  }

  .dx-table thead th {
    vertical-align: middle;
  }

  >>> .hcc {
    border-radius: 5%;
    color: DimGray;
    text-align: center;
    border: 1px solid DarkGray;
    font-size: 12px;
    padding: 0px 1px 0px 1px;
    margin: 0px 2px 0px 2px;
  }

  >>> .hcc28 {
    color: #005695;
    border-color: #005695;
    opacity: 0.8;
  }

  .VuePagination__count {
    display: none;
  }

  .header-flex-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .subtle-add-icon {
    cursor: pointer;
    color: #606266; /* Darker gray */
    font-size: 14px;
    margin-left: 4px;
    margin-right: 6px;
    transition: color 0.2s;
    flex-shrink: 0;
  }

  .subtle-add-icon:hover {
    color: #409eff;
  }

  .context-menu {
    position: fixed;
    background: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 3000;
    min-width: 120px;
  }

  .context-menu-item {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;
    transition: background-color 0.2s;
  }

  .context-menu-item:hover {
    background-color: #f5f7fa;
    color: #409eff;
  }

  .context-menu-item i {
    margin-right: 8px;
    font-size: 12px;
  }

  .delete-button {
    border: 1px solid transparent;
  }

  .dx-row:nth-child(even) .delete-button {
    border: 1px solid #606266;
    border-radius: 100%;
  }

  .input-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .move-left-icon {
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    transition: color 0.2s;
    flex-shrink: 0;
  }

  .move-left-icon:hover {
    color: #409eff;
  }
</style>
